import { css } from '@emotion/core'
import { colors } from '@fs/zion-ui'

export default {
  divider: css`
    height: 32px;
    width: 1px;
    background-color: ${colors.transparent.gray40};
  `,
}
